import React from "react";
import clsx from "clsx";
import Countdown from "~/components/days-till/Countdown";
import { TFunction } from "i18next";
import { DateDiff } from "~/helpers/dates.server";
import { getLocale } from "~/i18n";
import { useLocation } from "react-router";
import invariant from "tiny-invariant";


interface Props {
  total: number;
  t: TFunction;
  diff: DateDiff;
  event: string,
  units: string;
  hydrated?: boolean;
}


const TimeSince: React.FC<Props> = (
  {
    t,
    total,
    diff,
    event,
    units,
    hydrated = true,
  }
) => {
  const locale = getLocale(useLocation().pathname);
  invariant(locale);

  return <>
    <div className="text-slate-900 dark:text-white uppercase">
      <div
        className={clsx(
          "w-full  mb-10 md:mb-6 flex flex-col sm:flex-row flex-wrap sm:gap-10 justify-center items-center sm:items-baseline",
          "text-center font-extrabold"
        )}
      >
          <span className="text-[7rem] md:text-[11rem]">
            {total}
          </span>
        <span
          className="text-[3rem] md:text-[5rem] md:text-left uppercase">
            {t(units, { count: total })}
          </span>
      </div>
      <div className="pb-12 text-center text-[1.5rem] sm:text-[2.5rem] font-bold">
        { ["days", "months", "years"].includes(units)
          ? t("elapsed_male", { count: total })
          : t("elapsed_female", { count: total })
        } {event}
      </div>
    </div>

    <Countdown diff={diff} t={t} hydrated={hydrated} />
  </>;
};

export default TimeSince;